module.exports = __webpack_public_path__ + "static/media/swapArrow.364ec05d.svg";